var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFaPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 46.675,
    viewBox: "0 0 40 46.675",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6,32.678A5,5,0,0,0,0,36.948V73.615a5,5,0,0,0,7.6,4.271l30-18.333a5,5,0,0,0,0-8.542Z",
    transform: "translate(0 -31.942)",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaPlay);
export default __webpack_public_path__ + "static/media/faPlay.5b9fe2d51c4a6c0da2f40b2471ccf8e9.svg";
export { ForwardRef as ReactComponent };